export const VALIDATION_RULES = {
  minLength: /(?=.{8,})/,
  lowerAndUpperCase: /(?=.*[a-z])(?=.*[A-Z])/,
  specialCharacterOrDigit: /(?=.*[!@#$%^&*_0-9])/,
};
